import React from "react";

/**
 * Segmented per-week progress bar shared by long-running season loaders.
 *
 * `weeks` (optional) labels each segment with its week number so the user can
 * see exactly which weeks are done when the range does not start at week 1.
 */
const WeekProgressBar = ({ loaded, total, weeks = null, caption = null }) => {
    const labels = Array.isArray(weeks) && weeks.length === total ? weeks : null;
    const defaultCaption =
        loaded < total
            ? `Loading week ${labels ? labels[loaded] : loaded + 1} of ${labels ? labels[total - 1] : total}…`
            : "All weeks loaded — building records…";

    return (
        <div className="space-y-3">
            <div className="flex gap-1">
                {Array.from({ length: total }, (_, i) => (
                    <div
                        key={labels ? labels[i] : i}
                        className={`h-2.5 flex-1 rounded-sm transition-colors duration-300 ${
                            i < loaded ? "bg-mustard" : "bg-border"
                        }`}
                        title={labels ? `Week ${labels[i]}` : undefined}
                    />
                ))}
            </div>
            {labels && (
                <div className="flex gap-1">
                    {labels.map((week, i) => (
                        <span
                            key={week}
                            className={`flex-1 text-center font-mono text-[0.6rem] font-bold ${
                                i < loaded ? "text-forest" : "text-text-muted/60"
                            }`}
                        >
                            {week}
                        </span>
                    ))}
                </div>
            )}
            <p className="text-text-muted font-sans text-xs font-semibold text-center">
                {caption ?? defaultCaption}
            </p>
        </div>
    );
};

export default WeekProgressBar;
